import { useCallback } from 'react';
import { PriceSlider } from '@bwoty-web/ui-kit';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import FilterGroup from './FilterGroup';

export const FilterPrice = (props) => {
  const { header, hidden, max, min, value, valueLabel, onFilter } = props;
  const { siteId } = useSelector((state) => state.settings);

  const updateFilter = useCallback(
    (price) => {
      onFilter('price', { price });
    },
    [onFilter],
  );

  const v = value && value <= max && value >= 0 ? value : max;

  return (
    <FilterGroup header={header}>
      <PriceSlider
        max={max}
        min={min}
        value={v}
        siteId={siteId}
        uniqueId="lms-filter_price"
        valueLabel={valueLabel}
        onChange={updateFilter}
        hidden={hidden}
      />
    </FilterGroup>
  );
};

FilterPrice.propTypes = {
  header: PropTypes.node,
  onFilter: PropTypes.func,
  hidden: PropTypes.bool,
  max: PropTypes.number,
  min: PropTypes.number,
  value: PropTypes.number,
  valueLabel: PropTypes.node,
};
